<script async setup lang="ts"></script>

<template>
  <section class="features">
    <article class="feature">
      <img src="/assets/icons/chat.svg" alt="" />
      <p>
        Получите новые знания и знакомства, познакомьтесь с экспертами в вашей
        области
      </p>
    </article>

    <article class="feature">
      <img src="/assets/icons/like.svg" alt="" />
      <p>
        Раскройте свой потенциал через передачу опыта и знаний, выступая как
        спикер
      </p>
    </article>
  </section>
</template>

<style scoped lang="scss">
.features {
  gap: 40px;
  display: flex;
  margin-bottom: 40px;

  .feature {
    gap: 36px;
    display: flex;
    flex-direction: column;

    padding: 40px;
    border-radius: 40px;
    background: var(--color-mono-10);

    img {
      width: 64px;
      height: 64px;
      padding: 20px;
      border-radius: 20px;
      background: var(--color-mono-0);
    }

    p {
      line-height: 30px;
      font-size: var(--font-size-l);
      color: var(--color-mono-1000);
      font-weight: var(--font-weight-light);
    }
  }
}
</style>
